import { InspectorRootNodes, noDataTag } from '@/plugins/devtools/shared'

import type { Devtools } from '@/plugins/devtools/api'
import type { CustomInspectorStateNode } from '@/plugins/devtools/shared'
import type { CustomInspectorNode } from '@vue/devtools-kit'

const rootNodeTitle = 'Lua Data'

interface LuaDataRecord {
  eventId: string
  id: string
  label: string
  nodes: CustomInspectorStateNode[]
}
const luaData: LuaDataRecord[] = []

export function setupLuaNode (devtools: Devtools): void {
  devtools.rootNodeGetters.push((payload) => {
    if (payload.filter && !rootNodeTitle.toLowerCase().includes(payload.filter.toLowerCase())) {
      return null
    }

    const label = `${rootNodeTitle} (Limit: ${devtools.api!.getSettings().luaLogLimit})`
    const node: Required<CustomInspectorNode> = {
      id: InspectorRootNodes.LUA,
      label,
      children: luaData.map((record) => {
        return {
          id: record.id,
          label: record.label,
        }
      }),
      tags: [],
      name: '',
      file: '',
    }
    if (!node.children.length) {
      node.tags.push(noDataTag)
    }
    return node
  })

  devtools.stateGetters.push((payload) => {
    if (devtools.getRootNode(payload.nodeId) !== InspectorRootNodes.LUA) return

    const data = luaData.find((record) => record.id === payload.nodeId)
    if (data) {
      payload.state = { data: data.nodes }
    }
  })
}
